import { toSignal } from "@angular/core/rxjs-interop";
import { Component, inject, input, output, signal } from "@angular/core";
import { RouterLinkWithHref } from "@angular/router";
import { AmpRouterEvent } from "@dcc/shared/amplitude";
import { ApplicationIds } from "@dcc/shared/configs/vo-applications";
import { AuthService } from "@dcc/vestas-online/auth/data-access";
import { SidebarComponent } from "@dcc/shared/feature-flags/sidebar-feat";
import { locales } from "@dcc/shared/util-locale-manager";
import { VdsIconAnchorComponent, VdsIconButtonComponent } from "@cce/design-system/button";
import { VdsHeaderComponent } from "@cce/design-system/header";
import { VdsIconComponent } from "@cce/design-system/icon";
import { VdsTooltipDirective } from "@cce/design-system/tooltip";
import { UserStore } from "@dcc/vestas-online/data-access";
import { User } from "@dcc/vestas-online/domain";
import { UpdatePromptButtonComponent } from "@dcc/vestas-online/feat-service-worker";
import { HeaderAreaComponent } from "@dcc/vestas-online/notification-area/feat";
import { ApplicationAllowedDirective } from "@dcc/vestas-online/shared/application-is-allowed-feature";
import { LogoComponent } from "@dcc/vestas-online/shared/ui";
import { LanguageMenuComponent } from "@dcc/vestas-online/shared/ui-language-dropdown";
import { TranslocoDirective } from "@jsverse/transloco";
import { UserMenuComponent } from "./user-menu/user-menu.component";
import { BreakpointObserver } from "@angular/cdk/layout";
import { map } from "rxjs";

@Component({
    selector: "vo-shell-header",
    templateUrl: "./header.component.html",
    host: {
        class: "contents print:hidden"
    },
    imports: [
        RouterLinkWithHref,
        LanguageMenuComponent,
        UserMenuComponent,
        VdsIconButtonComponent,
        VdsIconComponent,
        SidebarComponent,
        VdsHeaderComponent,
        TranslocoDirective,
        LogoComponent,
        VdsIconAnchorComponent,
        HeaderAreaComponent,
        VdsTooltipDirective,
        ApplicationAllowedDirective,
        UpdatePromptButtonComponent,
        AmpRouterEvent
    ]
})
export class HeaderComponent {
    private breakpointObserver = inject(BreakpointObserver);
    private userStore = inject(UserStore);
    private authService = inject(AuthService);

    protected readonly applicationIds = ApplicationIds;
    protected readonly locales = locales;

    protected readonly isHandset = toSignal(this.breakpointObserver.observe("(max-width: 599px)").pipe(map((result) => result.matches)));

    readonly title = input.required<string>();
    protected readonly user = this.userStore.user;

    protected readonly showFeatureFlags = signal<boolean>(false);

    readonly toggleAppDrawer = output<void>();

    logout(): void {
        void this.authService.logout();
    }

    toggleFeatureFlagsDrawer() {
        this.showFeatureFlags.update((val) => !val);
    }

    setUserLocale(locale: { id: string; value: string }, user: User) {
        this.userStore.updateUser({ ...user, language: locale.id });
    }
}
